export class ForgeProjectContextFeedback {
    constructor(model) {
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.contextId = model.contextId;
        this.createdByUserId = model.createdByUserId;
        this.createdAt = new Date(model.createdAt);
        this.message = model.message;
        this.description = model.description;
        this.conversation = model.conversation;
        this.sentiment = model.sentiment;
        this.state = model.state;
        this.category = model.category;
        this.metadata = model.metadata;
        this.llm = model.llm;
    }
    toRemote() {
        return this;
    }
}
